<template>
  <div class="activity-page">
    <div class="clear">
      <h2 class="paging-title">活动奖励</h2>
    </div>
    <div class="no-data" v-if="activityList.length==0">暂无数据</div>
    <div class="module-item" v-for="(item,index) in activityList" :key="index">
      <div>
        <h3 class="module-title">{{item.ActivityName}}</h3>
        <div class="tip-wrap">
          <i class="icon-info">?</i>
          <div class="tooltip" v-if="item.ActivityDescription">{{item.ActivityDescription}}</div>
        </div>
      </div>
      <div class="clear">
        <div class="activity-left">
          <dl class="info-dl">
            <dt class="label">活动时间：</dt>
            <dd class="value">{{item.ActivityDtStart}} - {{item.ActivityDtEnd}}</dd>
          </dl>
          <dl class="info-dl">
            <dt class="label">活动奖励：</dt>
            <dd class="value" v-if="item.ActivityTypeLv2==3">
              <div v-for="(obj,i) in item.BonusSections" :key="i" v-html="obj.content"></div>
            </dd>
            <dd class="value" v-else>{{item.BonusStr}}</dd>
          </dl>
        </div>
        <div class="activity-right">
          <div class="count" v-if="item.ActivityTypeLv2!=3">
            已完成：{{item.UserCompleteNum}}
            <span v-if="item.ActivityTypeLv2==4">单</span>
            <span v-else>家</span>
          </div>
          <div class="money" v-if="item.BonusType==1">累计奖励：{{item.UserBonusNum | formatPrice}}元</div>
          <div class="money" v-if="item.BonusType==3">累计奖励：{{item.UserBonusNum}}分</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {GetActivitiesByUser} from '@/scripts/api.js'
import {FormatTime} from '@/scripts/util.js'
export default {
  data(){
    return{
      pageSize:100,
      pageNo:1,
      activityList:[],
    }
  },
  computed:{
    userCode(){
      if(this.$store.state.userInfo){
        return this.$store.state.userInfo.UserCode;
      }
      return '';
    },
  },
  watch:{
    userCode(value,old){
      if(value && value!=old){
        this.init();
      }
    },
  },
  created(){
    if(this.userCode){
      this.init();
    }
  },
  methods:{
    init(){
      GetActivitiesByUser({
        PageSize:this.pageSize,
        PageNo:this.pageNo,
        UserCode:this.userCode,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          let list=r.Data.Lines;
          for (let i = 0; i < list.length; i++) {
            list[i].ActivityDtStart=FormatTime(list[i].ActivityDtStart,'yyyy-MM-dd');
            list[i].ActivityDtEnd=FormatTime(list[i].ActivityDtEnd,'yyyy-MM-dd');
            if(list[i].ActivityTypeLv2==3){
              for (let j = 0; j < list[i].BonusSections.length; j++) {
                list[i].BonusSections[j]['content']=`${list[i].BonusSections[j].JobAccumulateMoneyStart}-${list[i].BonusSections[j].JobAccumulateMoneyEnd}&emsp;&emsp;${list[i].BonusSections[j].BonusStr}`
              }
            }
          }
          this.activityList=[...list];
        }
      })
    }
  }
}
</script>
<style lang="scss">
.activity-page{
  .module-item{
    background-color:#F9F9F9;
    border:1px solid #E5E5E5;
    padding:20px 44px 20px 24px;
    position: relative;
    margin-top: 20px;
    .module-title{
      font-size: 16px;
      color: #333;
      line-height: 20px;
      margin-bottom: 10px;
      font-weight: 600;
      display:inline-block;
    }
    .tip-wrap{
      display:inline-block;
      vertical-align: middle;
      margin-top: -3px;
      position: relative;
      &:hover .tooltip{
        display:block;
      }
    }
    .icon-info{
      display:block;
      width: 16px;
      height: 16px;
      border-radius: 20px;
      background-color: #f75959;
      color: #fff;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .tooltip{
    position:absolute;
    left: 100%;
    top: -10px;
    width: 200px;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0 0 3px #ccc;
    border-radius: 4px;
    font-size: 12px;
    color: #666;
    line-height: 20px;
    margin-left: 10px;
    display:none;
    transition: all 0.1s linear;
    &:before,&:after{
      content:'';
      position: absolute;
      left: -12px;
      top: 12px;
      width: 0px;
      height: 0;
      border: 6px solid transparent;
      border-right-color: #ccc;
      z-index: 2;
    }
    &:after{
      border-right-color: #fff;
      z-index: 3;
      left: -11px;
    }
  }
  .activity-left{
    float: left;
    width: 600px;
  }
  .activity-right{
    float: left;
    width: 300px;
    margin-left: 20px;
  }
  .info-dl{
    font-size: 14px;
    color: #666;
    line-height: 24px;
    .label{
      float: left;
      width: 80px;
      white-space: nowrap;
    }
    .value{
      float: left;
      width: 520px;
      word-break: break-all;
    }
  }
  .count{
    float: left;
    font-size: 14px;
    color: #333;
    line-height: 24px;
  }
  .money{
    float: right;
    font-size: 14px;
    color: #333;
    line-height: 24px;
  }
}
</style>